// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LkG9UK6dx2G2Qs {
  font-weight: 700;
  margin-top: 12px;
  margin-bottom: 4px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin: 0;
}
.WuW_0yuUz4ztQL {
  display: flex;
  margin-top: 4px;
}
.WuW_0yuUz4ztQL .BehthRfzoC6y6H {
  margin-top: 2px;
  margin-left: 3px;
}
.WuW_0yuUz4ztQL .dikMdHgANvfU2d {
  padding: 8px;
  border-radius: 3px;
  width: 256px;
  max-height: 300px;
  margin-bottom: 8px;
  border-color: var(--ds-border, #091e4224);
  background-color: var(--ds-background-input, #ffffff);
  flex: 1;
  margin: 0;
}
.WuW_0yuUz4ztQL .dikMdHgANvfU2d option[disabled] {
  color: var(--ds-text-subtle, #44546f);
}
.WuW_0yuUz4ztQL .dikMdHgANvfU2d option[disabled] {
  color: var(--ds-text-subtle, #44546f);
}
.HTRsxwjYOHtS_8 {
  display: flex;
  align-items: center;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: normal;
}
.HTRsxwjYOHtS_8 .BehthRfzoC6y6H {
  margin-top: 2px;
  margin-left: 3px;
}
.HTRsxwjYOHtS_8 .tzg75f4KYiXcAF {
  flex: 1;
}
.YUks2Kl75Lmmww .szViRFV1DuKbEO {
  display: block;
  margin-top: 4px;
  padding: 8px;
}
.YUks2Kl75Lmmww label {
  cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorVisionLabel": `LkG9UK6dx2G2Qs`,
	"colorVisionOptions": `WuW_0yuUz4ztQL`,
	"checkbox": `BehthRfzoC6y6H`,
	"select": `dikMdHgANvfU2d`,
	"tota11yOptions": `HTRsxwjYOHtS_8`,
	"label": `tzg75f4KYiXcAF`,
	"accessibilityMenuWrapper": `YUks2Kl75Lmmww`,
	"link": `szViRFV1DuKbEO`
};
export default ___CSS_LOADER_EXPORT___;
